import React, { useEffect, useState } from 'react';

import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import AuditList from 'src/component/AuditList';
import useMediaQuery from '@mui/material/useMediaQuery';
import DeviceRotate from 'src/component/UI/DeviceRotate';
import variables from 'src/style/variable/variables.module.scss';
import { useTranslation } from 'src/i18n';
import { clearDevicesAuditTrail } from 'src/module/device/action';

export default function AuditContent (props) {
  const {
    deviceId,
  } = props;
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);
  const { t } = useTranslation();

  const isMobile = useMediaQuery(`(max-width: ${variables.mobileWidth})`);
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const [showRotateMessage, setShowRotateMessage] = useState(isMobile && isPortrait);
  useEffect(() => {
    setShowRotateMessage(isMobile && isPortrait);
  }, [isMobile, isPortrait]);

  function clearAuditTrail() {
    setCollapsed(!collapsed);
    dispatch(clearDevicesAuditTrail(deviceId));
  }


  return (
    <Paper data-testid='alarms-content'>
      <h3 className='expandable' onClick={() => clearAuditTrail()}>{t('device.auditTrail')} &nbsp;<span className='expand-arrow'>{collapsed ? '▲' : '▼'}</span></h3>
      {collapsed && !showRotateMessage ?
        <AuditList
          deviceId={deviceId}
        />
        : ''}

      {collapsed && showRotateMessage ?
        <DeviceRotate/>
        : null}
    </Paper>
  );
}

AuditContent.propTypes = {
  deviceId: PropTypes.string.isRequired
};
AuditContent.defaultProps = {

};
